/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Without a card (a prospect) the contact, birth number and identity document may be missing, and the client is never verified or signed. `incomplete` only ever describes a representative whose card lacks required fields
 */
export type MangoClientCardStatus = (typeof MangoClientCardStatus)[keyof typeof MangoClientCardStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MangoClientCardStatus = {
  missing: "missing",
  unsigned: "unsigned",
  signed: "signed",
  incomplete: "incomplete",
} as const;
